module.exports = __webpack_public_path__ + "static/5-382aaccfaf54a29ab4091e2097ab3d5b.jpg";